// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { ClaimTaskData, ClaimTaskErrors, ClaimTaskResponses, CreateActionPresetData, CreateActionPresetResponses, CreateLogData, CreateLogErrors, CreateLogResponses, CreateSnsAccountData, CreateSnsAccountResponses, DeleteActionPresetData, DeleteActionPresetResponses, DeletePhoneboardData, DeletePhoneboardErrors, DeletePhoneboardResponses, DeleteSnsAccountData, DeleteSnsAccountResponses, EnqueueTaskData, EnqueueTaskErrors, EnqueueTaskResponses, ExportLogsData, ExportLogsErrors, ExportLogsResponses, ExportToCsvData, ExportToCsvResponses, GetActionPresetData, GetActionPresetResponses, GetActionPresetsData, GetActionPresetsErrors, GetActionPresetsResponses, GetConnectedDeviceCountData, GetConnectedDeviceCountErrors, GetConnectedDeviceCountResponses, GetDashboardSummaryData, GetDashboardSummaryErrors, GetDashboardSummaryResponses, GetDevicesData, GetDevicesErrors, GetDevicesResponses, GetGroupsData, GetGroupsErrors, GetGroupsResponses, GetLogsData, GetLogsErrors, GetLogsResponses, GetNotificationsData, GetNotificationsErrors, GetNotificationsResponses, GetPhoneboardByIdData, GetPhoneboardByIdErrors, GetPhoneboardByIdResponses, GetPhoneboardsData, GetPhoneboardsErrors, GetPhoneboardsResponses, GetPhoneboardStatusSummariesData, GetPhoneboardStatusSummariesErrors, GetPhoneboardStatusSummariesResponses, GetSnsAccountsData, GetSnsAccountsResponses, GetTasksData, GetTasksErrors, GetTasksResponses, GetUnreadNotificationsData, GetUnreadNotificationsErrors, GetUnreadNotificationsResponses, HeartbeatData, HeartbeatErrors, HeartbeatResponses, ImportFromCsvData, ImportFromCsvResponses, LoginData, LoginResponses, LogoutData, LogoutResponses, MarkAllAsReadData, MarkAllAsReadErrors, MarkAllAsReadResponses, MarkAsReadData, MarkAsReadErrors, MarkAsReadResponses, MarkMultipleAsReadData, MarkMultipleAsReadErrors, MarkMultipleAsReadResponses, RefreshTokenData, RefreshTokenResponses, RegisterDeviceData, RegisterDeviceErrors, RegisterDeviceResponses, RegisterPhoneboardData, RegisterPhoneboardErrors, RegisterPhoneboardResponses, ReportTaskData, ReportTaskErrors, ReportTaskResponses, SearchDevicesData, SearchDevicesErrors, SearchDevicesResponses, SearchGroupsData, SearchGroupsErrors, SearchGroupsResponses, SearchLogsData, SearchLogsErrors, SearchLogsResponses, SearchPhoneboardsData, SearchPhoneboardsErrors, SearchPhoneboardsResponses, SearchPhoneboardStatusSummariesData, SearchPhoneboardStatusSummariesErrors, SearchPhoneboardStatusSummariesResponses, SearchSnsAccountsData, SearchSnsAccountsResponses, SearchTasksData, SearchTasksErrors, SearchTasksResponses, UpdateActionPresetData, UpdateActionPresetResponses, UpdatePhoneboardData, UpdatePhoneboardErrors, UpdatePhoneboardResponses, UpdateSnsAccountData, UpdateSnsAccountResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Delete SNS account
 *
 * SNS 계정을 삭제합니다
 */
export const deleteSnsAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteSnsAccountData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteSnsAccountResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/sns-accounts/{accountId}',
        ...options
    });
};

/**
 * Update SNS account
 *
 * 기존 SNS 계정을 업데이트합니다
 */
export const updateSnsAccount = <ThrowOnError extends boolean = false>(options: Options<UpdateSnsAccountData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateSnsAccountResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/sns-accounts/{accountId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete phoneboard
 *
 * 폰보드를 삭제합니다. JWT 인증이 필요합니다.
 */
export const deletePhoneboard = <ThrowOnError extends boolean = false>(options: Options<DeletePhoneboardData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeletePhoneboardResponses, DeletePhoneboardErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards/{id}',
        ...options
    });
};

/**
 * Get phoneboard by ID
 *
 * ID로 폰보드를 조회합니다. JWT 인증이 필요합니다.
 */
export const getPhoneboardById = <ThrowOnError extends boolean = false>(options: Options<GetPhoneboardByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPhoneboardByIdResponses, GetPhoneboardByIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards/{id}',
        ...options
    });
};

/**
 * Update phoneboard
 *
 * 기존 폰보드를 업데이트합니다. JWT 인증이 필요합니다.
 */
export const updatePhoneboard = <ThrowOnError extends boolean = false>(options: Options<UpdatePhoneboardData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdatePhoneboardResponses, UpdatePhoneboardErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 단건 알람 읽음 처리
 *
 * 특정 알람을 읽음 상태로 변경합니다
 */
export const markAsRead = <ThrowOnError extends boolean = false>(options: Options<MarkAsReadData, ThrowOnError>) => {
    return (options.client ?? client).put<MarkAsReadResponses, MarkAsReadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/notifications/{id}/read',
        ...options
    });
};

/**
 * 일괄 알람 읽음 처리
 *
 * 여러 알람을 한 번에 읽음 상태로 변경합니다
 */
export const markMultipleAsRead = <ThrowOnError extends boolean = false>(options: Options<MarkMultipleAsReadData, ThrowOnError>) => {
    return (options.client ?? client).put<MarkMultipleAsReadResponses, MarkMultipleAsReadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/notifications/read-multiple',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 전체 알람 읽음 처리
 *
 * 사용자의 모든 읽지 않은 알람을 읽음 상태로 변경합니다
 */
export const markAllAsRead = <ThrowOnError extends boolean = false>(options?: Options<MarkAllAsReadData, ThrowOnError>) => {
    return (options?.client ?? client).put<MarkAllAsReadResponses, MarkAllAsReadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/notifications/read-all',
        ...options
    });
};

/**
 * Action Preset 삭제
 *
 * Action Preset을 비활성화합니다(soft delete). 관리자 권한이 필요합니다.
 */
export const deleteActionPreset = <ThrowOnError extends boolean = false>(options: Options<DeleteActionPresetData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteActionPresetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/action-presets/{id}',
        ...options
    });
};

/**
 * Action Preset 상세 조회
 *
 * 특정 Action Preset의 상세 정보를 조회합니다.
 */
export const getActionPreset = <ThrowOnError extends boolean = false>(options: Options<GetActionPresetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetActionPresetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/action-presets/{id}',
        ...options
    });
};

/**
 * Action Preset 수정
 *
 * 기존 Action Preset을 수정합니다. 관리자 권한이 필요합니다.
 */
export const updateActionPreset = <ThrowOnError extends boolean = false>(options: Options<UpdateActionPresetData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateActionPresetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/action-presets/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Report task result
 *
 * 할당받은 작업의 실행 결과를 보고합니다
 */
export const reportTask = <ThrowOnError extends boolean = false>(options: Options<ReportTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<ReportTaskResponses, ReportTaskErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Enqueue task
 *
 * 큐에 새로운 작업을 추가합니다
 */
export const enqueueTask = <ThrowOnError extends boolean = false>(options: Options<EnqueueTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<EnqueueTaskResponses, EnqueueTaskErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/enqueue',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Claim task
 *
 * 실행 가능한 다음 작업을 할당받습니다
 */
export const claimTask = <ThrowOnError extends boolean = false>(options: Options<ClaimTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<ClaimTaskResponses, ClaimTaskErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/claim',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get all SNS accounts
 *
 * 인증된 사용자의 모든 SNS 계정을 페이지네이션으로 조회합니다
 */
export const getSnsAccounts = <ThrowOnError extends boolean = false>(options?: Options<GetSnsAccountsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSnsAccountsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/sns-accounts',
        ...options
    });
};

/**
 * Create SNS account
 *
 * 새로운 SNS 계정을 생성합니다
 */
export const createSnsAccount = <ThrowOnError extends boolean = false>(options: Options<CreateSnsAccountData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateSnsAccountResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/sns-accounts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Import SNS accounts from CSV
 *
 * CSV 파일에서 SNS 계정을 가져옵니다
 */
export const importFromCsv = <ThrowOnError extends boolean = false>(options?: Options<ImportFromCsvData, ThrowOnError>) => {
    return (options?.client ?? client).post<ImportFromCsvResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/sns-accounts/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get all phoneboards
 *
 * 페이지네이션을 사용하여 모든 폰보드를 조회합니다. JWT 인증이 필요합니다.
 */
export const getPhoneboards = <ThrowOnError extends boolean = false>(options?: Options<GetPhoneboardsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPhoneboardsResponses, GetPhoneboardsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards',
        ...options
    });
};

/**
 * Register phoneboard
 *
 * 새로운 폰보드를 등록합니다. JWT 인증이 필요합니다.
 */
export const registerPhoneboard = <ThrowOnError extends boolean = false>(options: Options<RegisterPhoneboardData, ThrowOnError>) => {
    return (options.client ?? client).post<RegisterPhoneboardResponses, RegisterPhoneboardErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get task logs
 *
 * 페이지네이션 및 필터링으로 작업 실행 로그를 조회합니다
 */
export const getLogs = <ThrowOnError extends boolean = false>(options?: Options<GetLogsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetLogsResponses, GetLogsErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/logs',
        ...options
    });
};

/**
 * Create log
 *
 * 새로운 작업 실행 로그를 생성합니다
 */
export const createLog = <ThrowOnError extends boolean = false>(options: Options<CreateLogData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateLogResponses, CreateLogErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/logs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Send device heartbeat
 *
 * 서버에 디바이스 상태를 보고합니다
 */
export const heartbeat = <ThrowOnError extends boolean = false>(options: Options<HeartbeatData, ThrowOnError>) => {
    return (options.client ?? client).post<HeartbeatResponses, HeartbeatErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/heartbeat',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Register device
 *
 * 새로운 디바이스를 등록하거나 이미 등록된 경우 기존 디바이스를 반환합니다
 */
export const registerDevice = <ThrowOnError extends boolean = false>(options: Options<RegisterDeviceData, ThrowOnError>) => {
    return (options.client ?? client).post<RegisterDeviceResponses, RegisterDeviceErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/devices/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Refresh access token
 *
 * 리프레시 토큰을 사용하여 새로운 액세스 토큰을 생성합니다
 */
export const refreshToken = <ThrowOnError extends boolean = false>(options: Options<RefreshTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<RefreshTokenResponses, unknown, ThrowOnError>({
        url: '/v1/auth/refresh',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * User logout
 *
 * 리프레시 토큰을 무효화합니다
 */
export const logout = <ThrowOnError extends boolean = false>(options: Options<LogoutData, ThrowOnError>) => {
    return (options.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
        url: '/v1/auth/logout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * User login
 *
 * 사용자를 인증하고 JWT 토큰을 반환합니다
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => {
    return (options.client ?? client).post<LoginResponses, unknown, ThrowOnError>({
        url: '/v1/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Action Preset 목록 조회
 *
 * 플랫폼별 또는 전체 Action Preset 목록을 조회합니다.
 */
export const getActionPresets = <ThrowOnError extends boolean = false>(options?: Options<GetActionPresetsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetActionPresetsResponses, GetActionPresetsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/action-presets',
        ...options
    });
};

/**
 * Action Preset 생성
 *
 * 새로운 Action Preset을 생성합니다. 관리자 권한이 필요합니다.
 */
export const createActionPreset = <ThrowOnError extends boolean = false>(options: Options<CreateActionPresetData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateActionPresetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/action-presets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get all tasks
 *
 * 페이지네이션을 사용하여 모든 작업을 조회합니다. API 키 및 JWT 인증을 모두 지원합니다.
 */
export const getTasks = <ThrowOnError extends boolean = false>(options?: Options<GetTasksData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTasksResponses, GetTasksErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/tasks',
        ...options
    });
};

/**
 * Search tasks
 *
 * 플랫폼, 액션, 상태, dedupeKey로 작업을 검색합니다. 페이지네이션을 지원합니다
 */
export const searchTasks = <ThrowOnError extends boolean = false>(options?: Options<SearchTasksData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchTasksResponses, SearchTasksErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/search',
        ...options
    });
};

/**
 * Search SNS accounts
 *
 * 계정 ID 및 플랫폼으로 SNS 계정을 검색합니다. 페이지네이션을 지원합니다
 */
export const searchSnsAccounts = <ThrowOnError extends boolean = false>(options?: Options<SearchSnsAccountsData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchSnsAccountsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/sns-accounts/search',
        ...options
    });
};

/**
 * Export SNS accounts to CSV
 *
 * 모든 SNS 계정을 CSV 형식으로 내보냅니다
 */
export const exportToCsv = <ThrowOnError extends boolean = false>(options?: Options<ExportToCsvData, ThrowOnError>) => {
    return (options?.client ?? client).get<ExportToCsvResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/sns-accounts/export',
        ...options
    });
};

/**
 * Get connected device count
 *
 * 폰보드에 연결된 디바이스 수를 조회합니다. JWT 인증이 필요합니다.
 */
export const getConnectedDeviceCount = <ThrowOnError extends boolean = false>(options: Options<GetConnectedDeviceCountData, ThrowOnError>) => {
    return (options.client ?? client).get<GetConnectedDeviceCountResponses, GetConnectedDeviceCountErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards/{id}/devices/count',
        ...options
    });
};

/**
 * Get phoneboard status summaries
 *
 * 연결 상태 및 헬스 상태를 포함한 모든 폰보드의 상태 요약을 조회합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const getPhoneboardStatusSummaries = <ThrowOnError extends boolean = false>(options?: Options<GetPhoneboardStatusSummariesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPhoneboardStatusSummariesResponses, GetPhoneboardStatusSummariesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards/status-summary',
        ...options
    });
};

/**
 * Search phoneboard status summaries
 *
 * 상태, 이름, 위치로 폰보드 상태 요약을 검색합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const searchPhoneboardStatusSummaries = <ThrowOnError extends boolean = false>(options?: Options<SearchPhoneboardStatusSummariesData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchPhoneboardStatusSummariesResponses, SearchPhoneboardStatusSummariesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards/status-summary/search',
        ...options
    });
};

/**
 * Search phoneboards
 *
 * 상태, 이름, 위치로 폰보드를 검색합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const searchPhoneboards = <ThrowOnError extends boolean = false>(options?: Options<SearchPhoneboardsData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchPhoneboardsResponses, SearchPhoneboardsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards/search',
        ...options
    });
};

/**
 * Get all groups
 *
 * 페이지네이션을 사용하여 모든 그룹을 조회합니다. JWT 인증이 필요합니다.
 */
export const getGroups = <ThrowOnError extends boolean = false>(options?: Options<GetGroupsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetGroupsResponses, GetGroupsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards/groups',
        ...options
    });
};

/**
 * Search groups
 *
 * 이름과 설명으로 그룹을 검색합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const searchGroups = <ThrowOnError extends boolean = false>(options?: Options<SearchGroupsData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchGroupsResponses, SearchGroupsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/phoneboards/groups/search',
        ...options
    });
};

/**
 * 전체 알람 목록 조회
 *
 * 사용자의 전체 알람 목록을 페이지네이션으로 조회합니다
 */
export const getNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/notifications',
        ...options
    });
};

/**
 * 읽지 않은 알람 목록 조회
 *
 * 사용자의 읽지 않은 알람 목록을 페이지네이션으로 조회합니다
 */
export const getUnreadNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetUnreadNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUnreadNotificationsResponses, GetUnreadNotificationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/notifications/unread',
        ...options
    });
};

/**
 * Search logs
 *
 * 플랫폼, 디바이스로 작업 로그를 검색합니다. 페이지네이션을 지원합니다
 */
export const searchLogs = <ThrowOnError extends boolean = false>(options?: Options<SearchLogsData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchLogsResponses, SearchLogsErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/logs/search',
        ...options
    });
};

/**
 * Export logs as CSV
 *
 * 작업 로그를 CSV 파일로 내보냅니다
 */
export const exportLogs = <ThrowOnError extends boolean = false>(options?: Options<ExportLogsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ExportLogsResponses, ExportLogsErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/logs/export',
        ...options
    });
};

/**
 * Get all devices
 *
 * 페이지네이션을 사용하여 모든 디바이스를 조회합니다. JWT 인증이 필요합니다.
 */
export const getDevices = <ThrowOnError extends boolean = false>(options?: Options<GetDevicesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDevicesResponses, GetDevicesErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/devices',
        ...options
    });
};

/**
 * Search devices
 *
 * 상태 및 디바이스 이름으로 디바이스를 검색합니다. 페이지네이션을 지원합니다. JWT 인증이 필요합니다.
 */
export const searchDevices = <ThrowOnError extends boolean = false>(options?: Options<SearchDevicesData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchDevicesResponses, SearchDevicesErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/devices/search',
        ...options
    });
};

/**
 * Get dashboard summary
 *
 * 현재 메트릭 및 일일 비교와 함께 대시보드 요약을 반환합니다. 포함 내용: 연결된 디바이스, SNS 계정, 작업, 어제와 비교한 작업 성공률.
 */
export const getDashboardSummary = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardSummaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDashboardSummaryResponses, GetDashboardSummaryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v1/dashboard/summary',
        ...options
    });
};
